module.exports = __webpack_public_path__ + "media/AtmPinPad.037ef112.mp4";